import { Component, type ErrorInfo, type ReactNode } from 'react'

interface Props { children: ReactNode }
interface State { failed: boolean }

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { failed: false }

  static getDerivedStateFromError(): State {
    return { failed: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Omikina recovered from an interface error.', error, info)
  }

  render() {
    if (!this.state.failed) return this.props.children
    return <main className="app-error" role="alert">
      <span className="eyebrow">OMIKINA · RECOVERY MODE</span>
      <h1>The atlas hit an unexpected interface error.</h1>
      <p>Your data and settings were not changed. Reload the current version to continue.</p>
      <button onClick={() => window.location.reload()}>RELOAD OMIKINA</button>
    </main>
  }
}
